import { forwardRef, type Ref, type SVGProps } from "react";
const IconBikeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M24.5 15a6 6 0 0 0-.73.05h-.11a5 5 0 0 0-.68.15l-1-1.86V9h2a1 1 0 0 0 0-2H19a1 1 0 0 0 0 2h1v3h-8v-2h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2h1v3.36l-1 1.86a5 5 0 0 0-.68-.15h-.11A6 6 0 0 0 7.5 15a5.5 5.5 0 0 0 0 11 5.6 5.6 0 0 0 1-.1h.05a6 6 0 0 0 .95-.28A5.47 5.47 0 0 0 13 21H7.6a1 1 0 0 1-.85-.45.91.91 0 0 1 0-.93L9 15.22a5.3 5.3 0 0 1 1.74.86L12 14h5l-2.5 5h-1.71a5.48 5.48 0 0 0-2-2.92L9 19h3.78a5.3 5.3 0 0 1 .22 1.5 4 4 0 0 1 0 .5h2.1a1 1 0 0 0 .89-.53L19 14h1l1.16 2.14a5.6 5.6 0 0 1 1.8-.92l2.33 4.4a.93.93 0 0 1-.44 1.28 1 1 0 0 1-1.34-.43l-2.36-4.32a5.5 5.5 0 0 0-1.81 2.44v.07a4 4 0 0 0-.15.49s0 .08 0 .12-.06.31-.08.47a1 1 0 0 0 0 .15 4 4 0 0 0 0 .62A5.5 5.5 0 1 0 24.5 15"
    />
    <path
      fill="currentColor"
      d="M7.5 15a5.5 5.5 0 1 0 0 11 5.5 5.5 0 1 0 0-11m17 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 1 0 0-11"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBikeFilledSVG);
ForwardRef.displayName = "IconBikeFilled";
export { ForwardRef as IconBikeFilled };
